import styled from 'styled-components';

const ReportFieldItem = styled.div`
  display: grid;
  grid-template-columns: auto min-content;
`;

export { ReportFieldItem };
